// sp_frontend/src/components/GoogleAnalytics.js
import React from 'react';
import { Helmet } from 'react-helmet';

const GoogleAnalytics = () => (
  <Helmet>
    <script async src="https://www.googletagmanager.com/gtag/js?id=G-3JVGB068K4"></script>
    <script>
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-3JVGB068K4');
      `}
    </script>
  </Helmet>
);

export default GoogleAnalytics;
